import { defineComponent as _defineComponent } from 'vue'
import Action, { ActionProps } from '@/components/atoms/action/Action.vue';
import TableContainer from '@/components/molecules/table/TableContainer.vue';

interface RequestPreviewProps {
  previewFields: string[];
  validatedData: Record<string, any>;
  data: Record<string, any>;
  actions: ActionProps[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RequestPreview',
  props: {
    previewFields: null,
    validatedData: null,
    data: null,
    actions: null
  },
  setup(__props: any) {

const props = __props as {
  previewFields: string[];
  validatedData: Record<string, any>;
  data: Record<string, any>;
  actions: ActionProps[];
};



const getDetailTableHeader = () => {
  return {
    columns: props.previewFields.map((field) => ({
      label: props.data[field] ? props.data[field].label : field,
    })),
  };
};

const getDetailTableBody = () => {
  return [
    {
      cells: props.previewFields.map((field) => ({
        value: props.validatedData[field] || '',
      })),
    },
  ];
};

return { __sfc: true,props, getDetailTableHeader, getDetailTableBody, Action, TableContainer }
}

})